/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Página sin título',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Crea una nueva página e insértala como enlace',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Crear página de Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Abrir en Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Se ha creado tu página',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Página creada',
  'editorExtensionLinkCreate.confluencePage.title': 'Crear página nueva',
  'editorExtensionLinkCreate.genericError.description': 'Actualiza la página y vuelve a intentarlo.',
  'editorExtensionLinkCreate.genericError.title': 'Se ha producido un error',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Crea una incidencia en línea e insértala como enlace',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Crear incidencia de Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Abrir en Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Se ha creado tu incidencia',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Incidencia creada',
  'editorExtensionLinkCreate.jiraIssue.title': 'Crear nueva incidencia',
  'editorExtensionLinkCreate.keyword.create': 'crear',
  'editorExtensionLinkCreate.keyword.issue': 'incidencia',
  'editorExtensionLinkCreate.keyword.new': 'nuevo',
  'editorExtensionLinkCreate.keyword.page': 'página',
  'editorExtensionLinkCreate.keyword.publish': 'publicar',
  'editorExtensionLinkCreate.keyword.raise': 'generar',
  'editorExtensionLinkCreate.keyword.space': 'espacio',
  'editorExtensionLinkCreate.keyword.ticket': 'ticket',
};
